import conf from './conf'
import qrcode from './qrcode'

export default {
  wechat: {
    info: {
      ...conf,
      ...qrcode
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/wechat/wechat.js